export default __webpack_public_path__ + "static/media/Group1.8fb9a45c.svg";